import { Component, ElementRef } from '@angular/core';
import { MapTooltipComponent } from '../../map/map-tooltip/map-tooltip.component';
import { PigeonholeTooltipContent } from '../../map/map-tooltip/map-tooltip.types';
import { getGroundClass } from 'src/app/helpers/ground-class.helper';

@Component({
  selector: 'app-pigeonhole-map-tooltip',
  templateUrl: './pigeonhole-map-tooltip.component.html',
  styleUrls: ['../../map/map-tooltip/map-tooltip.component.scss']
})
export class PigeonholeMapTooltipComponent extends MapTooltipComponent<PigeonholeTooltipContent> {

  constructor(protected override elementRef: ElementRef) {
    super(elementRef);
  }

  isEmpty(): boolean {
    return !this.content || this.content.empty;
  }

  getTooltipBackgroundClass(group: string): string {
    return getGroundClass(group);
  }
}
